import classNames from 'classnames'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CreateInviteButton } from './CreateInviteButton.component'
import { DeleteUserButton } from './DeleteUserButton.component'
import { User } from '../../../../../../../entities-next/user'

export type UserTableActionsProps = ExtendableStyles &
  Testable & {
    user: User
  }

export function UserTableActions({ className, user }: UserTableActionsProps) {
  const { classes } = useStyles()

  return (
    <div className={classNames(className, classes.actionCell)}>
      <CreateInviteButton className={classes.actionButton} user={user} />
      <DeleteUserButton className={classes.actionButton} user={user} />
    </div>
  )
}

const useStyles = makeStyles()(({ palette, spacing }) => ({
  actionCell: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButton: {
    width: spacing(5.5),
    height: spacing(5.5),
  },
  testingUserChip: {
    marginRight: spacing(-0.5),
    color: palette.common.white,
    backgroundColor: palette.primary.main,
  },
}))
